import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PowerBiReportService } from '../../powerbi-report/powerbi-report.service';
import { SharedService } from '../../../shared/services/shared.service';
import { DtoModuleSubcategory, DtoSubCategory, PackageInformation } from '../../../models/package-center.model';
import { DtoUserReportView } from '../../../models/userProfile.model';
import { firstValueFrom } from 'rxjs';
import { IReportBookmark, ISlicerState } from 'powerbi-models';
import { PowerBiSlicerDescriptionService } from '../../../shared/services/PowerBiSlicerDescriptionService';

@Component({
  selector: 'app-my-insights',
  templateUrl: './my-insights.component.html'
})
export class MyInsightsComponent
implements OnInit, OnDestroy
{
  @Input({required: true}) packageInformation!: PackageInformation;
  @Input({required: false}) selectedToolkit: DtoSubCategory|null=null;
  iconHover: number|null = null;
  startupSubcategory: number|null = null;
  startupSubcategoryPageName: string|null = null;
  thisToolkit: DtoSubCategory|null=null;
  thisModule: DtoModuleSubcategory|null = null;
  thisToolkitGroupName: string | null = null;
  selectReportView: DtoUserReportView|null=null;
  //this is a clone of the selected view in edit mode
  //so that it can be explicitly committed
  editReportView:DtoUserReportView|null=null;
  
  reportViewBookmark: IReportBookmark|null=null;
  reportSlicerStates: { pageName: string; visualName: string; state: ISlicerState; }[] | null=null;
  reportSlicerDescriptions:{
    slicerState: { pageName: string; visualName: string; state: ISlicerState; },
    filters:{
      table:string,
      column: string,
      values: string
    }[]
    
  }[] = [];
  constructor(
    private toasterService: ToastrService,
    private powerBiService: PowerBiReportService,
    private sharedService: SharedService,
    private powerBiSlicerDescriptionService: PowerBiSlicerDescriptionService
  ){

  }
  
  ngOnDestroy(): void {
    this.editReportView=null;
  }

  ngOnInit(): void {
    
    //const auth = this.sharedService.getLoginToken();
    const userProfile = this.sharedService.getUserProfile();
    this.startupSubcategory = userProfile.startupSubcategory;
    this.startupSubcategoryPageName = userProfile.pageName
    
    if(this.startupSubcategory==null
    && this.packageInformation.modules.length>1
    && this.packageInformation.modules[0].subCategories.length>0){
      const firstStartupId=this.packageInformation.modules[0].subCategories[0].packageSubCategoryId;
      this.startupSubcategory = firstStartupId;
    }

    var highlightToolkit: number|null = null;
    if(this.selectedToolkit!=null)
    {
      highlightToolkit = this.selectedToolkit?.packageSubCategoryId??0
    }
    else {
      highlightToolkit = this.startupSubcategory;
    }

    if(highlightToolkit==null || highlightToolkit==0)
    {  
      this.thisToolkit = null;
      this.thisModule = null;
      this.thisToolkitGroupName=null;
    }
    else{
      for(const m of this.packageInformation.modules){
        for(const sg of m.subCategoryGrouping!){
          for(const sc of sg.items){
            if(sc.packageSubCategoryId==highlightToolkit){
              this.thisToolkit = sc;
              this.thisModule = m;
              this.thisToolkitGroupName=sg.groupName;
              break;
            }
          }
          if(this.thisToolkit!=null) {
            break;
          };
        }
        
        if(this.thisToolkit!=null) {
          break;
        };
      }
    }

    if(this.thisToolkit!=null) {
      this.getToolkitViews();      
    };
    
  }

    
  deleteSlicerFilter(
    slicer: {
    slicerState: { pageName: string; visualName: string; state: ISlicerState; }; filters: {
    table: string;
    column: string;
    values: string;
    }[];
  }) {
    this.editReportView=null;
    if(this.selectReportView!.snapShotType!='Filters') return;

    if(!confirm('Please confirm that you intend to delete the selected slicer settings')) return;

    const newSlicers = this.reportSlicerStates!.filter((x)=>x.visualName!=slicer.slicerState.visualName);
    if(newSlicers.length==0){
      this.toasterService.warning('There must be atleast one filter in a view.','Delete Filter')
      return;
    }

    const snapShotData = JSON.stringify(newSlicers);
    
    this.selectReportView!.snapShotData = snapShotData;

    const tsv=this.toasterService;
    this.powerBiService.SaveUserReportView(this.selectReportView!)
    .subscribe(
        {
          next:(response)=>{
            var newView = response as DtoUserReportView;
            tsv.success(newView.viewName + ' has been saved.','Analytics Personalisation');
            this.parseSnapshotData();

            this.sharedService.triggerUserReportViewSource(newView, 'save')
            
          },
          error(err) {
            tsv.error('Error saving analytics personalisation settings','Analytics Personalisation');
          },
        });
  }

  selectToolkit(module: DtoModuleSubcategory|null,groupName: string|null, toolkit: DtoSubCategory|null) {
    this.thisToolkit = toolkit;
    this.thisModule = module;
    this.thisToolkitGroupName = groupName;
    this.getToolkitViews();
  }

  async getToolkitViews()
  {
    this.editReportView=null;
    if(this.thisToolkit==null) {
      this.selectReportView=null;
      return;
    }

    const auth = this.sharedService.getLoginToken();
    
    var toolkitReportViews = await firstValueFrom(
     this.powerBiService.GetUserReportViews(
      auth.userId,this.thisToolkit?.subCategoryId,false)) as DtoUserReportView[];

    this.thisToolkit.userReportViews = toolkitReportViews;
    this.selectReportView=null;
    const urv = toolkitReportViews.find(x=>x.isStartup)??null;
    this.selectReportView=urv;
    this.thisToolkit.defaultUserReportViewId = urv?.userReportViewId??0;
    this.thisToolkit.userReportViewId = this.thisToolkit.defaultUserReportViewId;
    

    this.parseSnapshotData();
  }

  toggleStartup(packageSubCategoryId: number) {
    const userProfile = this.sharedService.getUserProfile();
    if(this.startupSubcategory==packageSubCategoryId){
      //switch off
      userProfile.startupSubcategory=null;
      userProfile.pageName=null;
      if(this.selectedToolkit!=null)
        this.selectedToolkit.isStartUp=false;
      for(const m of this.packageInformation.modules){
        
        for(const sc of m.subCategories){
          if(sc.isStartUp){
            sc.isStartUp=false;
          }
        }
      }
    }
    else{
      //change
      userProfile.startupSubcategory=packageSubCategoryId;
      userProfile.pageName=null;
      if(this.selectedToolkit!=null)
        this.selectedToolkit.isStartUp=(this.selectedToolkit.packageSubCategoryId == packageSubCategoryId);

      for(const m of this.packageInformation.modules){
        for(const sc of m.subCategories){
          sc.isStartUp=(sc.packageSubCategoryId==packageSubCategoryId);
        }
      }
    }

    
    this.startupSubcategoryPageName = userProfile.pageName;
    this.startupSubcategory=userProfile.startupSubcategory;
    this.sharedService.saveUserProfile('startupSubcategory');
  }

  selectView(userView: DtoUserReportView|null) {
    if(this.selectReportView==null && userView==null) return;
    if(this.selectReportView?.userReportViewId==userView?.userReportViewId) return;

    this.editReportView=null;
    this.selectReportView=userView;
    this.thisToolkit!.userReportViewId=userView?.userReportViewId??0;
    this.parseSnapshotData();
  }

  parseSnapshotData(){
    this.reportSlicerStates=null;
    this.reportSlicerDescriptions=[]
    this.reportViewBookmark=null;
    const urv = this.selectReportView;
    if(urv?.snapShotData!=null){   
      if(urv?.snapShotType=='Snapshot'){
        this.reportViewBookmark = JSON.parse(urv!.snapShotData) as IReportBookmark;
      }
      else{
        this.reportSlicerStates = JSON.parse(urv!.snapShotData??'{}') as 
        {
          pageName: string,
          visualName:string, 
          state:ISlicerState
        }[];

        for(const sl of this.reportSlicerStates){
          
          const slicer: {
            slicerState: { pageName: string; visualName: string; state: ISlicerState; };
            filters: {
              table: string;
              column: string;
              values: string;
            }[];
          } = {
            slicerState: sl,
            filters: this.powerBiSlicerDescriptionService.describeFilters(sl.state)
          };
          
          this.reportSlicerDescriptions.push(slicer);
        }
      }
    }
  }

  toogleInitialView(rv: DtoUserReportView|null) {

    if(rv==null){
      this.thisToolkit!.defaultUserReportViewId = 0;

      for(const item of this.thisToolkit?.userReportViews!){
        const isInitial = false;
        if(item.isStartup != isInitial)
        {
          item.isStartup = isInitial;
          this.powerBiService.SaveUserReportView(item).subscribe({
            next:(response: DtoUserReportView)=>{
              this.toasterService.info(`Saved ${item.viewName}`, 'Toolkit Customisation');
              return response;
            }
          });
        }
      }
    }
    else
    {
     
      this.thisToolkit!.defaultUserReportViewId = rv.userReportViewId;
      
      for(const item of this.thisToolkit?.userReportViews!){
        const isInitial = (item.userReportViewId == rv.userReportViewId);
        if(item.isStartup != isInitial)
        {
          item.isStartup = isInitial;
          if(isInitial) item.isFavourite =  true;
          this.powerBiService.SaveUserReportView(item).subscribe({
            next:(response: DtoUserReportView)=>{
              this.toasterService.info(`Saved ${item.viewName}`, 'Toolkit Customisation');
              return response;
            }
          });
        }
      }
    }
  }

    
  deleteReportView(rv: DtoUserReportView) {
    this.editReportView=null;
    if(!confirm('Please confirm that you intend to delete the selected toolkit view')) return;
    
    const newlist = this.thisToolkit!.userReportViews?.filter(x=>x.userReportViewId!=rv.userReportViewId);
    if(this.thisToolkit!.defaultUserReportViewId==rv.userReportViewId)
      this.thisToolkit!.defaultUserReportViewId=0;

    this.powerBiService.DeleteUserReportView(rv.userReportViewId)
    .subscribe((x)=>{
      this.thisToolkit!.userReportViews=newlist;
      if(this.selectReportView==rv){
        this.selectReportView=null;
        this.reportViewBookmark=null;
      }
      this.toasterService.info(`Deleted ${rv.viewName}`, 'Toolkit Customisation');
    });
  }

  SaveShared(urv: DtoUserReportView) {
    this.powerBiService.SaveUserReportView(urv).subscribe({
      next:(response: DtoUserReportView)=>{
        if(urv.isShared)
          this.toasterService.info(`Added ${urv.viewName} to shared.`, 'Toolkit Customisation');
        else
          this.toasterService.info(`Removed ${urv.viewName} from shared.`, 'Toolkit Customisation');
        return response;
      }
    });
  }

  SaveFavourite(urv: DtoUserReportView) {
    this.powerBiService.SaveUserReportView(urv).subscribe({
      next:(response: DtoUserReportView)=>{
        if(urv.isFavourite)
          this.toasterService.info(`Added ${urv.viewName} to favourites.`, 'Toolkit Customisation');
        else
          this.toasterService.info(`Removed ${urv.viewName} from favourites.`, 'Toolkit Customisation');
        return response;
      }
    });
  }

  
  startEditName(rv: DtoUserReportView){
    this.editReportView = JSON.parse( JSON.stringify(this.selectReportView))
  }

  cancelEdit(rv: DtoUserReportView){
    this.editReportView = null;
  }

  commitEdit(rv: DtoUserReportView){
    if(this.editReportView==null) return;
    if(this.selectReportView==null) return;
    if(this.editReportView.userReportViewId!=this.selectReportView.userReportViewId) return;

    if(this.editReportView.viewName.length==0)
    {
      this.toasterService.error('Toolkit view name cannot be empty','Toolkit Customisation');
      return;
    }
    
    this.selectReportView.viewName = this.editReportView.viewName;
    const tsv = this.toasterService;
    this.powerBiService.SaveUserReportView(this.selectReportView!)
    .subscribe(
        {
          next:(response)=>{
            var newView = response as DtoUserReportView;
            this.editReportView = null;
            
            tsv.success(newView.viewName + ' has been saved.','Analytics Personalisation');
            this.parseSnapshotData();

            this.sharedService.triggerUserReportViewSource(newView, 'save')
            
          },
          error(err) {
            tsv.error('Error saving analytics personalisation settings','Analytics Personalisation');
          },
        });
    
  }


}
